<template>
  <v-app
    :style="{
      height: '100%',
      background: '#E0F2F1'
    }"
  >
    <v-snackbar
      :timeout="6000"
      v-model="snackbar.mostrar"
      app
      centered
      top
      elevation="10"
      light
      style="z-index: 99 !important; padding: 0 !important"
    >
      <v-alert border="top" :type="snackbar.color" text prominent class="mb-0">
        {{ snackbar.mensaje }}
        <template v-slot:append>
          <v-btn icon class="ml-2" @click="cerrarAlerta()">
            <v-icon :color="snackbar.color">mdi-close-circle-outline</v-icon>
          </v-btn>
        </template>
      </v-alert>
    </v-snackbar>
    <app-side-bar v-if="mostrar"></app-side-bar>
    <app-toolbar v-if="mostrar"></app-toolbar>

    <v-idle
      v-if="env === 'production' && rutaActual !== 'login' && rutaActual"
      v-show="false"
      @idle="onidle"
      @remind="onremind"
      :loop="true"
      :reminders="[30]"
      :wait="5"
      :duration="300"
    />
    <global-loader />
    <v-main class="mb-10">
      <router-view />
    </v-main>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import SideBarVue from "./components/app/SideBar.vue";
import FooterVue from "./components/app/FooterApp.vue";
import ToolbarVue from "./components/app/ToolbarApp.vue";
import auth from "./services/auth";
import { mapState, mapActions } from "vuex";
import GlobalLoader from "./components/app/GlobalLoader.vue";
export default {
  name: "App",
  components: {
    "app-side-bar": SideBarVue,
    "app-footer": FooterVue,
    "app-toolbar": ToolbarVue,
    GlobalLoader
  },

  data: function () {
    return {
      rutaActual: ""
    };
  },
  computed: {
    ...mapState(["snackbar"]),
    mostrar() {
      return (
        this.rutaActual &&
        this.rutaActual !== "login" &&
        this.rutaActual !== "crear_contrasena" &&
        this.rutaActual !== "fin_firma_ecert" &&
        this.rutaActual !== "mantencion"
      );
    },
    env() {
      return process.env.NODE_ENV;
    }
  },
  methods: {
    ...mapActions(["mostrarAlerta", "cerrarAlerta", "setParametros"]),
    onidle() {
      auth.cerrarSesion();
      alert("Se cerró su sesión por inactividad");
    },
    onremind(time) {
      let payload = {
        mensaje:
          "Se va a cerrar su sesión por inactividad en " + time + " segundos",
        color: "warning",
        mostrar: true
      };
      this.mostrarAlerta(payload);
    }
  },
  async mounted() {
    this.rutaActual = this.$route.name;
  },
  watch: {
    "$route.name"(value) {
      this.rutaActual = value;
    }
  }
};
</script>

<style lang="css">
.ql-editor {
  padding: 0px !important;
  min-height: 0px;
  color: rgba(0, 0, 0, 0.8);
}

.trunc-text {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
.p-margin p {
  margin: 0px !important;
  margin-bottom: 0px !important;
}
.lato {
  font-family: "Lato", sans-serif !important;
}
.alerta {
  font-family: "Open Sans", sans-serif;
  font-weight: 300;
  font-size: 20px;
}
.v-alert .v-icon {
  align-self: center !important;
}
.primaryGradient {
  background-image: linear-gradient(
    to right,
    #34a693 0%,
    #42c8b1 51%,
    #34a693 100%
  );
}
.v-slide-group__prev {
  display: none !important;
}
.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  margin: 0 !important;
  min-width: 0px !important;
}
.v-snack__content {
  padding: 0 !important;
}
.v-snack__action {
  display: none;
}
.v-data-table-header th {
  padding-top: 10px !important;
  vertical-align: top !important;
}
.v-messages__message {
  hyphens: none !important;
}
.info-cliente .v-list-item {
  height: 58px !important;
}

.link-style a {
  color: white !important;
  text-decoration: none !important;
}
.link-style a:hover {
  text-decoration: underline !important;
}
</style>
